import { render, staticRenderFns } from "./popper-position.vue?vue&type=template&id=47210b39&scoped=true&"
import script from "./popper-position.vue?vue&type=script&lang=js&"
export * from "./popper-position.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47210b39",
  null
  
)

export default component.exports